module.exports = __webpack_public_path__ + "img/005.85322103.png";